import React from 'react';
export function Footer() {
  return <footer className="w-full py-12 px-4 sm:px-6 lg:px-8 border-t border-brand-gold/20" data-id="element-109">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-110">
        <h3 className="text-brand-gold font-bold text-lg mb-2" data-id="element-111">
          Mega Pack: Protocolo Salir del Veraz
        </h3>
        <p className="text-gray-400 text-sm mb-6" data-id="element-112">
          Recursos legales para personas con deudas en Veraz, Nosis y BCRA
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 text-gray-500 text-sm mb-8" data-id="element-113">
          <span data-id="element-114">@infinitamente.digital</span>
          <span className="hidden sm:inline" data-id="element-115">•</span>
          <span data-id="element-116">soporteinfinitamente@gmail.com</span>
        </div>

        <p className="text-gray-600 text-xs mb-4" data-id="element-117">
          © 2025 InfinitaMenteDigital. Todos los derechos reservados.
        </p>

        <p className="text-gray-700 text-[10px] max-w-2xl" data-id="element-118">
          Este producto tiene carácter exclusivamente educativo e informativo.
          No constituye asesoramiento jurídico profesional.
        </p>
      </div>
    </footer>;
}